import * as distributors from 'app/mocks/data/machines/all/distributors'
import * as fridgesWeight from 'app/mocks/data/machines/all/fridgesWeight'
import * as lockersCold from 'app/mocks/data/machines/all/lockersCold'
import * as lockersDry from 'app/mocks/data/machines/all/lockersDry'

import { PlanogramShort, StatusPlanogram } from 'app/types/machines/planogram'
import { OrderMachine } from 'app/types/shared/machine'

export const planogramShort1: PlanogramShort = {
    id: 1,
    name: 'Planogram 1',
    status: StatusPlanogram.enum.INACTIVE,
    order: OrderMachine.enum.A,
    machine: distributors.distributor1,
    address: '0',
    activity_start: '2024-04-30T16:49:16.690057+02:00',
}

export const planogramShort2: PlanogramShort = {
    id: 2,
    name: 'Planogram 2',
    status: StatusPlanogram.enum.PENDING,
    order: OrderMachine.enum.B,
    machine: lockersCold.lockerCold1,
    address: '0',
    activity_start: '2024-04-30T16:49:16.690057+02:00',
}

export const planogramShort3: PlanogramShort = {
    id: 3,
    name: 'Planogram 3',
    status: StatusPlanogram.enum.ACTIVE,
    order: OrderMachine.enum.A,
    machine: lockersDry.lockerDry1,
    address: '0',
    activity_start: '2024-04-30T16:49:16.690057+02:00',
}

export const planogramShort4: PlanogramShort = {
    id: 4,
    name: 'Planogram 4',
    status: StatusPlanogram.enum.ACTIVE,
    order: OrderMachine.enum.A,
    machine: fridgesWeight.fridgeWeight1,
    address: '0',
    activity_start: '2024-04-30T16:49:16.690057+02:00',
}

export const planogramShort5: PlanogramShort = {
    id: 5,
    name: 'Planogram 5',
    status: StatusPlanogram.enum.ACTIVE,
    order: OrderMachine.enum.A,
    machine: fridgesWeight.fridgeWeight2,
    address: '0',
    activity_start: '2024-04-30T16:49:16.690057+02:00',
}

export const planogramShort6: PlanogramShort = {
    id: 6,
    name: 'Planogram 6',
    status: StatusPlanogram.enum.ACTIVE,
    order: OrderMachine.enum.A,
    machine: distributors.distributor2,
    address: '0',
    activity_start: '2024-04-30T16:49:16.690057+02:00',
}

export const planogramShort7: PlanogramShort = {
    id: 7,
    name: 'Planogram 7',
    status: StatusPlanogram.enum.ACTIVE,
    order: OrderMachine.enum.B,
    machine: lockersCold.lockerCold2,
    address: '0',
    activity_start: '2024-04-30T16:49:16.690057+02:00',
}

export const planogramShort8: PlanogramShort = {
    id: 8,
    name: 'Planogram 8',
    status: StatusPlanogram.enum.ACTIVE,
    order: OrderMachine.enum.C,
    machine: lockersDry.lockerDry2,
    address: '0',
    activity_start: '2024-04-30T16:49:16.690057+02:00',
}

export const planogramShort9: PlanogramShort = {
    id: 9,
    name: 'Planogram 9',
    status: StatusPlanogram.enum.ACTIVE,
    order: OrderMachine.enum.A,
    machine: fridgesWeight.fridgeWeight3,
    address: '0',
    activity_start: '2024-04-30T16:49:16.690057+02:00',
}

export const planogramShort10: PlanogramShort = {
    id: 10,
    name: 'Planogram 10',
    status: StatusPlanogram.enum.ACTIVE,
    order: OrderMachine.enum.A,
    machine: lockersDry.lockerDry3,
    address: '0',
    activity_start: '2024-04-30T16:49:16.690057+02:00',
}
